import { makeStyles } from '@material-ui/core';
import MuiTheme from '../../../../theme';
import { getThemeStyle, spacingUnits } from '../../../../theme/theme';

export default makeStyles(
	{
		root: {
			backgroundColor: getThemeStyle('paletteCommonWhite'),
			width: '100%',
			overflowX: 'hidden',
		},
		greyHeader: {
			backgroundColor: getThemeStyle('palettePrimary500'),
		},
		greyHero: {
			backgroundColor: getThemeStyle('palettePrimary500'),
			'& .MuiTypography-h1': {
				color: getThemeStyle('paletteCommonWhite'),
			},

			'& .MuiTypography-body1': {
				color: getThemeStyle('paletteCommonWhite'),
			},
		},
		row: {
			paddingTop: spacingUnits(7),
			paddingBottom: spacingUnits(12),
			[MuiTheme.breakpoints.up('md')]: {
				paddingTop: spacingUnits(9),
				paddingBottom: spacingUnits(25),
			},
		},
	},
	{
		name: 'businessContact',
	},
);
